import type { GhostSample } from './RaceTypes';

export class GhostRecorder {
  private samples: GhostSample[] = [];
  private lastSampleT = 0;

  reset() {
    this.samples = [];
    this.lastSampleT = 0;
  }

  record(time: number, position: { x: number; y: number; z: number }, heading: number) {
    if (time - this.lastSampleT < 0.1) return;
    this.lastSampleT = time;
    this.samples.push({ t: time, x: position.x, y: position.y, z: position.z, heading });
  }

  getSamples(): GhostSample[] {
    return this.samples;
  }
}
